import Icon from "@/components/icons";
import { ImageProps } from "../types";
import Image from "next/image";
import { cn } from "@/lib/utils";

export default function Quoted({
  imageurl = "",
  imagetitle = "",
  children,
  className = "",
  width = 33,
  height = 25,
}: ImageProps) {
  return (
    <div
      className={cn(
        "flex flex-col md:flex-row p-6 rounded-xl border border-1 border-putty-400 bg-white",
        className,
      )}
      style={{ lineHeight: "1.925rem" }}
    >
      {imageurl && (
        <div className="flex md:w-1/5 justify-center items-center mb-5 md:mr-5">
          <Image
            src={imageurl}
            alt={imagetitle || ""}
            width={219}
            height={245}
          />
        </div>
      )}
      <div className="flex-1">
        <div className="md:flex">
          <div className="mr-6 mb-6 text-brand-500">
            <Icon
              type="open-quote"
              svgProps={{
                width,
                height,
              }}
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
